import { useState, useEffect,useContext } from "react";
import axios from "../axiosInstances";
import { 
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Avatar,
  Grid,
  Fab,
  Tooltip,
  Rating,
  Button 
} from "@mui/material";
import { AddSharp } from '@mui/icons-material'
import { useTranslation } from "react-i18next";
import { ShoppingCartContext } from "./Context/ShoppingCartContext";
import { useNavigate } from 'react-router-dom'

function AI() {
  const [q, setQ] = useState("");
  const [a, setA] = useState("");

  const ask = async () => {
    alert(q)
    const res = await axios.post("/aiserver/report", {
      question: q
    },{
          headers: {
            "Content-Type": "application/json",
                  }
        },).then((data)=>{
       setA(data.data.answer);
    })
   
  };
  return (
    <div>
      <h2>AI Assistant</h2>
      <input onChange={(e) => setQ(e.target.value)} />
      <button onClick={ask}>Ask</button>
      <p>{a}</p>
    </div>
  );
}

export default AI;
